import { Link, navigate } from "gatsby"
import React, { useRef, useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { useLocation } from "@reach/router"
import Image from "gatsby-image"
import "./header.css"
import headerBackVid from "./../images/backgroundHeader.mp4"

const HeaderEN = () => {
  const location = useLocation()
  const wasRedirected = location.action === "PUSH" && !location.pathname.includes("/projects") && !location.state.noChange ? true : null

  const headerTimeout = useRef(null)

  useEffect(() => {
    if (wasRedirected) {
      closeHeader("REDIRECT")
    }
    return () => {
      clearTimeout(headerTimeout.current)
    }
  }, [wasRedirected])

  // query to get Logo of ITAY SHIFF and xButton
  const {
    logo: {
      childImageSharp: { fluid: logo },
    },
    xButton: {
      childImageSharp: { fixed: xButton },
    },
  } = useStaticQuery(graphql`
    {
      logo: file(relativePath: { eq: "itayLogoWhite.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }

      xButton: file(relativePath: { eq: "xButton.png" }) {
        childImageSharp {
          fixed(width: 70) {
            ...GatsbyImageSharpFixed_tracedSVG
          }
        }
      }
    }
  `)

  let closeHeader = (e, text) => {
    if (e === "REDIRECT") {
      document.getElementById("headerWrapper").firstChild.classList.remove("active")
      document.getElementsByTagName("main")[0].firstChild.classList.remove("active")
      document.getElementsByTagName("header")[0].classList.remove("active")
      document.body.style.overflow = "unset"
    } else {
      e.preventDefault()

      // Make it possible only in case that the transition ended
      if (getComputedStyle(document.body).overflow === "hidden") {
        if (text !== location.pathname && text !== undefined) navigate(text)

        document.getElementById("headerWrapper").firstChild.classList.remove("active")
        document.getElementsByTagName("main")[0].firstChild.classList.remove("active")

        if (window.innerWidth > 550) {
          headerTimeout.current = setTimeout(() => {
            document.getElementsByTagName("header")[0].classList.remove("active")
            document.body.style.overflow = "unset"
            if (location.pathname.includes("/projects")) document.getElementById("galleryProject").style.visibility = "visible"
          }, 1550)
        } else {
          headerTimeout.current = setTimeout(() => {
            document.getElementsByTagName("header")[0].classList.remove("active")
            document.body.style.overflow = "unset"
            if (location.pathname.includes("/projects")) document.getElementById("galleryProject").style.visibility = "visible"
          }, 1150)
        }
      }
    }
  }

  return (
    <header className={wasRedirected ? "active" : ""}>
      <div id="headerWrapper">
        <div className={wasRedirected ? "active" : ""}>
          <video autoPlay loop muted playsInline>
            <source src={headerBackVid} type="video/mp4" />
          </video>

          <span onClick={closeHeader} role="button" tabIndex={0}>
            <Image
              fixed={xButton}
              alt="סגור חלון ניווט"
              style={{
                position: "absolute",
                top: "10px",
                left: "10px",
                cursor: "pointer",
                zIndex: "5",
              }}
            />
          </span>

          <div id="innerColumnHeader">
            <div>
              <Link to="/he/" onClick={(e) => closeHeader(e, "/he/")}>
                <div>
                  <Image fluid={logo} imgStyle={{ objectFit: "contain" }} alt="לוגו איתי שיף" />
                </div>
              </Link>

              <Link to="/he/about" onClick={(e) => closeHeader(e, "/he/about")}>
                אודות
              </Link>

              <Link to="/he/" onClick={(e) => closeHeader(e, "/he/")}>
                תיק עבודות
              </Link>

              <Link to="/he/contact" onClick={(e) => closeHeader(e, "/he/contact")}>
                צור קשר
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default HeaderEN
